export default __webpack_public_path__ + "assets/uv-index-2.8490fcd9.svg";